import { render, staticRenderFns } from "./DsPollingWrapper.vue?vue&type=template&id=6fe38cc7&"
import script from "./DsPollingWrapper.vue?vue&type=script&lang=js&"
export * from "./DsPollingWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports